import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  position: fixed;
  top: 0;
  left: 0%;
  width: 100%;
  height: 100%;
  z-index: 4;
`;

const Backdrop = ({ toggle }) => <Content onClick={() => toggle()} />;

export default Backdrop;



// WEBPACK FOOTER //
// ./src/components/Backdrop/Backdrop.jsx